import React, { useState } from 'react';
import TextInput from '../Form/TextInput/TextInput';
import Section from './Section';
import Modal from '../Modal/Modal';
import {config} from '../Session/authConfig';

import {useCurrentUser} from '../../contexts/CurrentUserProvider';

/** @import {PasswordProps} from './PasswordTypes' */

const Password = (/** @type {PasswordProps} */ _props) => {
  const currentUser = useCurrentUser();
  
  // const [password, setPassword] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const editingClicked = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const goToLogin = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ e) => {
    e.preventDefault();
    setShowModal(false);
    if (currentUser && currentUser.logout) {
      currentUser.logout(config.loginUri);
    }
  };

  return (
    <>
      <Section title="Password" className="my-profile__password" editing={false} setEditing={editingClicked} hideEditing={false}>
          <TextInput value="∙∙∙∙∙∙∙∙∙∙" disabled type="password" />
      </Section>
      {showModal && 
                <Modal onClose={() => closeModal()} className="modal--fixed-height inactivity-modal" ignoreClickOutside={true}>
                <h2 className="modal__title login__title otp-modal__title">Update Password</h2>
                <p>To update your password return to the login screen <a href="#" onClick={goToLogin}>here</a> and select 'Forgot password'.</p>
                <p>Once updated, you’ll need to log back into your online dashboard with your new password.</p>
              </Modal>
      
      }
    </>
  );
};

export default Password;
